/*
* Created By Jaeuk Ryu <devp011>
*/
export const state = () => ({
  connTypeUrl: '/api/cm/vpn-branch/conntype',
  opTypeUrl: '/api/cm/vpn-branch/op-type',
  policyUrl: '/api/cm/vpn-branch/policy',
  iftmUrl: '/api/cm/vpn-branch/lftm',
  descUrl: '/api/cm/vpn-branch/desc',
  copyDescObject: void 0,
  copyIftmObject: void 0
})

export const mutations = {
  setCopyDescObject (state, item) {
    state.copyDescObject = item
  },

  setCopyIftmObject (state, item) {
    state.copyIftmObject = item
  }
}

export const actions = {
  async changeConnType ({store, commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.connTypeUrl}/${payload.rowItem.vpn_branch_id}/${payload.value}`, null, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      this.dispatch(`common/common/setIsChanged`, true)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async changeOpType ({store, commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.opTypeUrl}/${payload.rowItem.vpn_branch_id}/${payload.value}`, null, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      this.dispatch(`common/common/setIsChanged`, true)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async edtPolicyName ({store, commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.policyUrl}/${payload.id}/${payload.data}`, null, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      this.dispatch(`common/common/setIsChanged`, true)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async edtIftm ({store, commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.iftmUrl}/${payload.id}/${payload.data}`, null, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      this.dispatch(`common/common/setIsChanged`, true)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async edtDesc ({store, commit, state}, payload) {
    const axiosData = {
      'vpn_branch_desc': payload.data,
      'vpn_branch_id': payload.id
    }
    try {
      const data = await this.$axios.$put(state.descUrl, axiosData, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      this.dispatch(`common/common/setIsChanged`, true)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async pasteIftmObject ({state, commit, dispatch}, {cell, rowItem}) {
    try {
      const data = await this.$axios.$put(`${state.iftmUrl}/${rowItem.vpn_branch_id}/${state.copyIftmObject}`, null, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      this.dispatch(`common/common/setIsChanged`, true)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async pasteObject ({state, commit, dispatch}, {cell, rowItem}) {
    const axiosData = {
      'vpn_branch_desc': state.copyDescObject,
      'vpn_branch_id': rowItem.vpn_branch_id
    }
    try {
      const data = await this.$axios.$put(state.descUrl, axiosData, {successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      this.dispatch(`common/common/setIsChanged`, true)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
}

export const getters = {}
export const strict = false
